(ns app.front.view.common.link
  (:require [app.i18n.model :as i18n-model]
            [core.front.carbon :as cc]
            [core.front.href :as href]))


(defn link-or-text
  "Receives language, target-entity, and LocalizedString. Returns a link if target
  entity is :entity.type/business, otherwise returns just the text. Can (and should) be
  expanded to include other entity types as well"
  [lang target target-names]
  (case (:entity/type target)
    :entity.type/business
    (cc/link
      {:href (href/href :view/business {:business-id (:db/id target)})}
      (i18n-model/get-text-from-entities-or-map target-names lang))

    [:span
     (i18n-model/get-text-from-entities-or-map target-names lang)]))
